
function taskDetails(state = {
  task: {}, serviceExtraList: [], definedServiceList: [], definedServicePopStatus: '', status: [], serviceDefinedCostList: [], result: {},
  refers: [], transport: {}, serviceAccessories: []
}, action) {

  switch (action.type) {
    case "GET_DEFINED_SERVICE_LIST":
      return {
        ...state,
        definedServiceList: action.data
      };

    case "GET_DEFINED_SERVICE":
      return {
        ...state,
        serviceDefinedCostList: action.data
      };
    case "GET_REFERALS":
      return {
        ...state,
        refers: action.data
      };
    case "GET_EXTRA_SERVICE":
      return {
        ...state,
        extra: action.data
      };
    case "CHANGE_TRANSPORT":
      return {
        ...state,
        transport: action.data
      };
    case "GET_TRANSPORT_COST":
      return {
        ...state,
        transportCost: action.data
      };

    case "GET_USEDPART_COST":
      return {
        ...state,
        usedPartCost: action.data
      };

    case "GET_DEFINED_COST":
      return {
        ...state,
        definedCost: action.data
      };


    case "GET_TASKS_DETAILS":
      return {
        ...state,
        task: action.data
      };

    case "GET_TASKS_STATUS":
      return {
        ...state,
        status: action.data
      };

    case "GET_TASKS_EXTRA":
      return {
        ...state,
        serviceExtraList: action.data
      };


    case "SAVE_EXTRA":
      return {
        ...state,
        result: action.data
      };
    case "SET_DEFINEDSERVICES_POPUP":
      return {
        ...state,
        definedServicePopStatus: action.data
      }
    case "SERVICE_ACCESSORIES":
      return {
        ...state,
        serviceAccessories: action.data
      }
    default:
      return state;
  }
}

export default taskDetails;